export interface ValidationResult {
  valid: boolean
  errorMessage?: string
}

export const ValidResult: ValidationResult = {
  valid: true
}

export function allValid(results: { [K in string]: ValidationResult }): boolean {
  return Object.values(results).every(vr => vr.valid)
}

export const invalidValidationResult = (errorMessage: string): ValidationResult => {
  return {
    valid: false,
    errorMessage
  }
}